import { ParseResponse, FileColumns } from './models';
import { parse as papaParse, ParseResult, ParseError, Parser } from 'papaparse';
import { FieldDelimiter, HeaderInfo } from '@ssar-app/domain';

const DelimitersMap: Record<string, FieldDelimiter> = {
  ',': FieldDelimiter.COMMA,
  '|': FieldDelimiter.PIPE,
  '\\t': FieldDelimiter.TAB,
};

export const delimitedParser = (
  inputFile: string | File,
  headersInfo: HeaderInfo,
  loadLimit = 100,
): Promise<ParseResponse> => {
  const toReturn: FileColumns = [];
  let isHeaderProcessed = false;
  let hasScannedFullFile = true;
  let scannedMaxColumnCount = 0;
  let scannedRowsCount = 0;
  return new Promise((resolve, reject) => {
    let detectedFieldDelimiter: FieldDelimiter;
    let error: Error | undefined;
    papaParse(inputFile, {
      worker: false,
      skipEmptyLines: true,
      header: false,
      // preview: 100,
      complete: (_results, _file) => {
        resolve({
          data: toReturn,
          fieldDelimiter: detectedFieldDelimiter,
          headersInfo,
          hasScannedFullFile,
          scannedMaxColumnCount,
          scannedRowsCount,
        });
      },
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      step: (results: ParseResult<any>, parser: Parser) => {
        if (error) {
          reject(error);
        }
        if (scannedRowsCount >= loadLimit) {
          hasScannedFullFile = false;
          parser.abort();
        } else {
          if (!detectedFieldDelimiter) {
            const delimiter: FieldDelimiter | undefined =
              DelimitersMap[results?.meta?.delimiter];
            if (delimiter) {
              detectedFieldDelimiter = delimiter;
            } else {
              reject(
                new Error(
                  `Selected file doesn't have valid delimiter. Allowed delimiters: ${Object.keys(
                    DelimitersMap,
                  ).join(' or ')}`,
                ),
              );
            }
          }

          scannedMaxColumnCount = Math.max(
            results.data.length,
            scannedMaxColumnCount,
          );
          const { data, errors } = results;
          if (errors && errors.length) {
            reject(errors[0]);
          } else {
            if (!isHeaderProcessed && headersInfo.hasHeaders) {
              isHeaderProcessed = true;
            } else {
              data.forEach((entry, index) => {
                if (!toReturn[index]) {
                  toReturn[index] = [];
                }
                toReturn[index].push(entry);
              });
            }
            scannedRowsCount++;
          }
        }
      },
      error: (error: ParseError) => {
        reject(error);
      },
    });
  });
};
